import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {getHeadersURL,getFooterURL, getSubnavURL} from '../../constants/index'


const initialState = {
    loading: false,
    error: false,
    headerHTML: '',
    subNavHTML: '',
    footerHTML: ''
    
}

export const fetchHeader = createAsyncThunk('common/fetchHeader', (lang) => {
    return axios
      .get(getHeadersURL + "/" + lang) 
      .then(response => response.data)
  })
  export const fetchSubnav = createAsyncThunk('common/fetchSubnav', (lang) => {
    return axios
      .get(getSubnavURL+ "/" + lang) 
      .then(response => response.data)
  })
export const fetchFooter = createAsyncThunk('common/fetchFooter', (lang) => {
    return axios
      .get(getFooterURL + "/" + lang)
      .then(response => response.data)
  })
  

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        
        resetAlerts: (state) => {
            state.success = '';
            state.error = '';
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchHeader.pending, state => {
            state.loading = true
          })
          builder.addCase(fetchHeader.fulfilled, (state, action) => {
            state.loading = false
            const parser = new DOMParser();
            const doc = parser.parseFromString(action.payload, 'text/html');
            
            // state.headerHTML = doc
            console.log(doc)
            // state.headerHTML = action.payload
            state.headerHTML = doc
            state.error = ''
          })
          builder.addCase(fetchHeader.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
          })
          builder.addCase(fetchSubnav.pending, state => {
            state.loading = true
          })
          builder.addCase(fetchSubnav.fulfilled, (state, action) => {
            state.loading = false
            const parser = new DOMParser();
            const doc = parser.parseFromString(action.payload, 'text/html');
            
            // state.headerHTML = doc
            console.log(doc)
            // state.headerHTML = action.payload
            state.subNavHTML = doc
            state.error = ''
          })
          builder.addCase(fetchSubnav.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
          })
        builder.addCase(fetchFooter.pending, state => {
            state.loading = true
          })
          builder.addCase(fetchFooter.fulfilled, (state, action) => {
            state.loading = false
            const parser = new DOMParser();
            const doc = parser.parseFromString(action.payload, 'text/html');
            
            // state.headerHTML = doc
            console.log(doc)
            state.footerHTML = doc
            state.error = ''
          })
          builder.addCase(fetchFooter.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
          })
    }
})

export const { resetAlerts } = commonSlice.actions
export default commonSlice.reducer